module.exports = require("@swa-ui/authentication/src/components/MissingCorporateInformationLink/MissingCorporateInformationLink.module.scss");